

require('./styles');

var _logger = require('xo-beaver/dist/logger');

define(['squid/index', 'text!./template.html'], function (squid, template) {

    squid.module('xo-banner.directive', ['squid']).directive('xoBanner', function () {
        return {
            scope: {
                bannerImage: '='
            },
            template: template,
            transclude: true,
            link: function link(scope, element) {
                var deregisterWatcher = scope.$watch('bannerImage', function () {
                    if (scope.bannerImage) {
                        scope.imageStyle = {
                            'background-image': 'url(' + scope.bannerImage + ')'
                        };
                        deregisterWatcher(); // $watch returns a deregister function
                        deregisterWatcher = 'deregisterd'; // converting deregisterWatcher into a non-function
                    }

                    // Todo : remove logger from ui once proven stable on production
                    _logger.$logger.info('xoBanner', {
                        'watcher_enabled': angular.isFunction(deregisterWatcher)
                    });
                });
            }
        };
    });
});

_logger.$logger;


/*****************
 ** WEBPACK FOOTER
 ** ./components/xo-ui-components/src/banner/directive.js
 ** module id = 360
 ** module chunks = 1
 **/